module.exports = __webpack_public_path__ + "static/media/rejected.34103c57.svg";